// @flow
import React from 'react';
import Button from '../../components/button';
import { Wrapper, H1 } from './error.styles';

type Props = {};

export default (props: Props) => (
  <Wrapper>
    <H1>404</H1>
    <Button onClick={() => props.history.push('/')}>Back to home</Button>
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/pages/error/index.js